module.exports = __webpack_public_path__ + "media/images/85/circadian_rhytm_mimosa_pudica-50f69ed559cf83cdbe21b748c945c944.jpg";